import Axios from 'axios'
const API_HOST = process.env.VUE_APP_API_HOST
const API_VERSION = process.env.VUE_APP_API_VERSION
const WorkService = {
  /**
   * @description Get all work list data
   *
   * @returns {object}
   */
  // getWorkList(q, sort, page = 1, perPage = 1000) {
  getWorkList(exceptional, q, sort, page = 1, perPage = 1000) {
    const getWorkURL = `${API_HOST}/${API_VERSION}/listen/works/`
    let params = {
      q: q,
      sort,
      page,
      per_page: perPage
    }
    Object.keys(exceptional).forEach((param, index) => {
      params[param] = exceptional[param]
    })
    return Axios
      .get(getWorkURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Get work by id
   *
   * @returns {object}
   */
  getWorkById(workId) {
    const getURL = `${API_HOST}/${API_VERSION}/listen/works/${workId}`
    return Axios.request({
      method: 'GET',
      url: getURL,
      headers: {
        // Authorization: 'Bearer ' + token
      }
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  }
}
export default WorkService
